export default __webpack_public_path__ + "static/media/compiegne10.003da2ec.jpg";